module.exports = require('../uk')



// WEBPACK FOOTER //
// ./shared/config/authentication/de/index.js